// extracted by mini-css-extract-plugin
export var watermark = "WatermarkTwo-module--watermark--4UskA";
export var watermarkContainer = "WatermarkTwo-module--watermarkContainer--bBFc2";